module.exports = __webpack_public_path__ + "img/logo-dtp.9858504b.png";